import React, { createContext, useContext, useState } from 'react';

export const DEMO_USERS = {
  seeker: {
    email: 'demo.seeker@careernet.dev',
    password: 'DemoSeeker2024!',
    name: 'Alex Johnson',
    role: 'seeker_full',
    label: 'Career Seeker',
  },
  career_coach: {
    email: 'demo.coach@careernet.dev',
    password: 'DemoCoach2024!',
    name: 'Morgan Lee',
    role: 'coach_full',
    label: 'Career Coach',
  },
  admin: {
    email: 'demo.admin@careernet.dev',
    password: 'DemoAdmin2024!',
    name: 'Sam Rivera',
    role: 'admin',
    label: 'Administrator',
  },
};

const DEV_USER_TYPES = [
  { value: 'seeker', label: 'Career Seeker', icon: 'User', color: 'var(--color-primary)', description: 'Job seeker dashboard & tools' },
  { value: 'career_coach', label: 'Career Coach', icon: 'GraduationCap', color: 'var(--color-secondary)', description: 'Coach career seekers & track progress' },
  { value: 'admin', label: 'Admin', icon: 'Shield', color: '#7c3aed', description: 'System administration & reports' },
];

const DevUserContext = createContext({});

export const useDevUser = () => {
  const context = useContext(DevUserContext);
  if (!context) throw new Error('useDevUser must be used within DevUserProvider');
  return context;
};

export const DevUserProvider = ({ children }) => {
  const [activeType, setActiveType] = useState(
    () => localStorage.getItem('devActiveType') || 'seeker'
  );

  const handleSetActiveType = (type) => {
    localStorage.setItem('devActiveType', type);
    setActiveType(type);
  };

  const isDevSeeker = () => activeType === 'seeker';
  const isDevRecruiter = () => activeType === 'career_coach';
  const isDevAdmin = () => activeType === 'admin';

  const activeDemoUser = DEMO_USERS?.[activeType] || DEMO_USERS?.seeker;

  return (
    <DevUserContext.Provider value={{ activeType, setActiveType: handleSetActiveType, DEV_USER_TYPES, isDevSeeker, isDevRecruiter, isDevAdmin, activeDemoUser, DEMO_USERS }}>
      {children}
    </DevUserContext.Provider>
  );
};

export default DevUserContext;
